import React, { useEffect, useState } from "react";
import { useMeasure } from "react-use";
// import { useMedia } from "react-use";
import { Swiper, SwiperSlide } from "swiper/react";
import classNames from "classnames";
import { DateTime } from "luxon";
import { customNumSort, getInitialDatesArray } from "../utils/index";
import {
  checkIfHighlightedDateIsSecondToLast,
  getNewFetchDate,
  getNewHighlightedDate,
  newChangeDates,
  parseDay,
  getNewIndex,
  findSelectedDietIndex,
} from "../helpers/menuHelpers";
import faTimes from "../img/icons/times.svg";
import faCheck from "../img/icons/check.svg";
import faChevronDown from "../img/icons/downChevron.svg";
import faArrowDown from "../img/icons/down.svg";
import faArrowUp from "../img/icons/up.svg";
import faArrowLeft from "../img/icons/left.svg";
import faArrowRight from "../img/icons/right.svg";
import { EmptyMenu } from "../img/icons/emptyMenu";
import { SmallMenu } from "../img/icons/smallMenu";
import loader from "../img/gifs/dietlyLoader.gif";
import dietlyLogo from "../img/icons/dietlyLogo.svg";
import { Button } from "./Button";
import { findDietTagImg } from "../helpers/singleOfferHelpers";
import { CustomModal } from "./CustomModal";
import { Select } from "./Select";
import Icon from "./Icon";

import { getServerApiMenu } from "../api/client/companyDetailsApi";

export const MenuWidget = ({
  companyDietDetails,
  companyMenus,
  companyParams: { menuVisibleInDietly },
  path,
  firstDietId,
  showSelect,
  id,
  api
}) => {
  const [ref, { width }] = useMeasure();
  const isWide = width > 768;
  // const isWide = useMedia("(min-width: 768px)");
  const [selectedDiet, selectDiet] = useState([]);
  const [dates, setDates] = useState(getInitialDatesArray());
  const [menus, setMenus] = useState(companyMenus);
  const [isLoading, setIsLoading] = useState(false);
  const [swiperMenu, setSwiperMenu] = useState(null);
  const [highlightedDate, setHighLightedDate] = useState(
    DateTime.local().toISODate()
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  //------------------------------------ Fetches -------------------------------------------
  const fetchInitialMenu = async (selectedDiet, dates, cb) => {
    cb && cb(true);
    const query = encodeURIComponent(
      JSON.stringify({
        dietId: selectedDiet?.dietId,
        dates,
      })
    );
    try {
      const result = await getServerApiMenu(query, id, api);
      setMenus(result);
      // const { data } = result || {};
      // setMenus(data);
      cb && cb(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      cb && cb(false);
    }
  };

  const fetchSingleMenu = async (selectedDiet, dates) => {
    const query = encodeURIComponent(
      JSON.stringify({
        dietId: selectedDiet?.dietId,
        dates,
      })
    );
    const result = await getServerApiMenu(query, id, api);
    const { data } = result || {};
    setMenus({
      ...menus,
      ...data,
    });
  };
  //------------------------------------ Effects -------------------------------------------
  // Ustaw za pierwszym razem selecta na tę dietę, która została inicjalnie wybrana (firstDietId). Jak źle wybrana - ustaw pierwszą z listy
  useEffect(() => {
    selectDiet(companyDietDetails[0]);
    companyDietDetails.map((cdd) => {
      if (firstDietId === cdd.dietId) {
        selectDiet(cdd);
      }
    });
  }, [companyDietDetails, firstDietId]);

  //ustaw za pierwszym razem wyświetlane menu na to, które przychodzi w propsie (firstDietId)
  useEffect(() => {
    setMenus(companyMenus);
  }, [companyMenus]);

  //------------------------------------ Helpers -------------------------------------------

  const getNextDiet = (direction, currentIndex, length) => {
    const nextDietIndex =
      getNewIndex(direction, currentIndex, length ?? 0) ?? 0;
    return companyDietDetails[nextDietIndex] ?? {};
  };

  const setAndFetchDietData = (diet) => {
    fetchInitialMenu(diet, getInitialDatesArray(), setIsLoading);
    setDates(getInitialDatesArray());
    selectDiet(diet);
    setHighLightedDate(DateTime.local().toISODate());
  };

  //------------------------------------ Components -------------------------------------------
  const TopBarModal = () => {
    return (
      <div className="top-bar-modal">
        <h2 className="top-bar-modal__title h300" style={{fontFamily: "Rubik"}}>Wybierz dietę</h2>
        <span
          className="top-bar-modal__close"
          onClick={() => setIsModalOpen(false)}
          onKeyPress={() => setIsModalOpen(false)}
          role="button"
          tabIndex="0"
        >
          <Icon url={faTimes} path={path} />
        </span>
      </div>
    );
  };
  const ChooseDietModal = () => {
    return (
      <div>
        {companyDietDetails?.map((diet) => (
          <div
            className="catering-menu__carousel-diets-mobile-modal-item"
            key={diet?.dietId}
            onClick={() => {
              setAndFetchDietData(diet);
              setIsModalOpen(false);
            }}
            onKeyPress={() => {
              setAndFetchDietData(diet);
              setIsModalOpen(false);
            }}
            role="button"
            tabIndex="0"
          >
            <img
              alt={diet?.dietName ? diet?.dietName : "Placeholder"}
              src={
                diet?.dietImageUrl
                  ? diet?.dietImageUrl
                  : findDietTagImg(diet?.dietTag, path)
              }
            />
            <p
              className={classNames({
                "color-primary": diet === selectedDiet,
              })}
              style={{fontFamily: "Rubik"}}
            >
              {diet?.dietName}
              {diet === selectedDiet && (
                <Icon
                  classes="font-size-18 spacer-right-18 width-20"
                  url={faCheck}
                  path={path}
                />
              )}
            </p>
          </div>
        ))}
      </div>
    );
  };
  const MenuTitle = () => {
    return (
      <div className="display-flex justify-content-center align-items-center spacer-bottom-16 spacer-top-16">
        <div className="widget-title">Menu</div>
      </div>
    );
  };
  const BarWithSelectOnDesktop = () => {
    return (

      <div className="catering-menu__carousel-diets-desktop noselect">
        {companyDietDetails?.length > 0 && (
          <div className="width-500 display-flex">
            {/*<div className="width-400 spacer-right-8"></div>*/}
            <div className="width-400 spacer-right-8">
              <Select
                dietUrl
                items={companyDietDetails}
                selectedItem={selectedDiet}
                selectedItemKey="dietName"
                selectItem={(diet) => setAndFetchDietData(diet)}
                id="menuPicker"
                path={path}
                disabled={!showSelect}
              />
            </div>
            {
            showSelect &&
            <>

            <Button
              colorBlank
              containerClass="button-fixed-height spacer-right-4"
              icon={
                <Icon classes="color-gray-400" path={path} url={faArrowDown} />
              }
              onClick={() =>
                setAndFetchDietData(
                  getNextDiet(
                    "down",
                    findSelectedDietIndex(selectedDiet, companyDietDetails),
                    companyDietDetails?.length
                  )
                )
              }
            />
            <Button
              colorBlank
              containerClass={"button-fixed-height "}
              icon={
                <Icon classes="color-gray-400" url={faArrowUp} path={path} />
              }
              onClick={() => {
                setAndFetchDietData(
                  getNextDiet(
                    "up",
                    findSelectedDietIndex(selectedDiet, companyDietDetails),
                    companyDietDetails?.length
                  )
                );
              }}
            />
            </>
            }
          </div>
        )}
      </div>
    );
  };
  const BarWithSelectOnMobile = () => {
    return (
      <div
        className="catering-menu__carousel-diets-wrapper catering-menu__carousel-diets-wrapper--no-border spacer-bottom-16"
        onClick={() =>{
        if(showSelect){
        setIsModalOpen(true)}
        }
        }
        onKeyPress={() => setIsModalOpen(true)}
        role="button"
        tabIndex="0"
      >
        <img
          className={"catering-img"}
          alt={selectedDiet?.dietName ? selectedDiet?.dietName : "Placeholder"}
          src={
            selectedDiet?.dietImageUrl
              ? selectedDiet?.dietImageUrl
              : findDietTagImg(selectedDiet?.dietTag, path)
          }
        />
        <div className="display-flex justify-content-space-between align-items-center width-100-per">
          <div className="color-gray-800 margin-bottom-0 padding-left-4">{selectedDiet?.dietName}</div>
          {
          showSelect &&
          <Icon
            classes="color-gray-500 spacer-right-16 width-24"
            path={path}
            url={faChevronDown}
          />
          }
        </div>
      </div>
    );
  };
  const Loader = ({ path }) => {
    return (
      <div className="catering-menu__loader">
        <img
          className="catering-menu__loader-img"
          alt="Wczytywanie"
          src={(path && path + loader) || loader}
        />
        <span className="label-l spacer-top-16">Ładowanie menu...</span>
      </div>
    );
  };
  const MenuUnavailable = () => {
    return (
      <div className={classNames("catering-menu__empty-card", {})}>
        <EmptyMenu />
        <h6 className="label-m text-align-center">Menu nie jest dostępne</h6>
      </div>
    );
  };
  const NoDiets = () => {
    return (
      <div className="catering-menu__loader">
        <SmallMenu color="#1F2E4D" />
        <span className="label-l spacer-top-16 text-align-center max-width-330">
          Niestety catering nie udostępnia rozpisanego menu dla tej diety
        </span>
      </div>
    );
  };
  const Footer = () => {
    return (
      <footer className="footer">
        <p className="footer__text label-m">Powered by </p>
        <a href={`https://dietly.pl/?utm_source=catering&utm_medium=powered_by_dietly&utm_campaign=${id}`} target="_blank" rel="noreferrer">
          <img
            className="footer__logo"
            alt="Dietly"
            src={(path && path + dietlyLogo) || dietlyLogo}
          />
        </a>
      </footer>
    );
  };
  //------------------------------------ Return -------------------------------------------

  return (
    <>
      <CustomModal
        className="custom-modal"
        isOpen={isModalOpen}
        overlayClassName="custom-modal-overlay"
      >
        <TopBarModal />
        <ChooseDietModal />
      </CustomModal>
      <div
        className={classNames({
          "catering-menu": true,
          "widget-paddings__mobile": width < 768,
          "widget-paddings__desktop": width >= 768,
        })}
        ref={ref}
      >
        <MenuTitle />
        {isWide ? <BarWithSelectOnDesktop /> : <BarWithSelectOnMobile />}

        {menuVisibleInDietly ? (
          <div>
            {isLoading ? (
              <Loader path={path} />
            ) : (
              <div className="catering-menu__calendar">
                <Swiper
                  allowTouchMove={false}
                  initialSlide={6}
                  observeparents="true"
                  observer="true"
                  observeslidechildren="true"
                  onSwiper={setSwiperMenu}
                  spaceBetween={8}
                  slidesPerView="auto"
                  // breakpoints={{
                  //   0: {
                  //     slidesPerView: 1,
                  //   },
                  //   768: {
                  //     slidesPerView: 3,
                  //   },
                  // }}
                >
                  {dates?.map((date) => {
                    return (
                      <SwiperSlide
                        key={date}
                        className={classNames({
                          singleSlide: width < 768,
                          threeSlides: width > 768,
                          heightAuto: true,
                          "padding-bottom-20": true,
                        })}
                      >
                        {() => (
                          <div
                            className={classNames("flex-1 catering-menu__box", {
                              "catering-menu__box--gray":
                                date !== highlightedDate && isWide,
                              "catering-menu__box--margin":
                                date === highlightedDate && isWide,
                              "catering-menu__box--shadow":
                                date === highlightedDate,
                            })}
                            key={date}
                          >
                            <div className="catering-menu__buttons">
                              <Button
                                colorClean
                                containerClass={classNames(
                                  "color-gray-800 cursor-pointer, button__arrow",
                                  {
                                    "visibility-hidden":
                                      date !== highlightedDate && isWide,
                                  }
                                )}
                                icon={
                                  <Icon
                                    classes="button-clean"
                                    url={faArrowLeft}
                                    path={path}
                                  />
                                }
                                onClick={() => {
                                  if (
                                    !checkIfHighlightedDateIsSecondToLast(
                                      highlightedDate,
                                      dates
                                    )
                                  ) {
                                    swiperMenu.updateSlides();
                                    swiperMenu.slidePrev();
                                    return setHighLightedDate(
                                      getNewHighlightedDate(
                                        highlightedDate,
                                        "down"
                                      )
                                    );
                                  }
                                  return null;
                                }}
                              />
                              <div className="display-flex flex-direction-column align-items-center justify-content-center">
                                <div className="label-m text-align-center">
                                  <div>{parseDay("d.LL.yyyy", date)}</div>
                                  <div className="spacer-bottom-16 color-gray-400">
                                    {parseDay("cccc", date)}
                                  </div>
                                </div>
                              </div>
                              <Button
                                colorClean
                                containerClass={classNames(
                                  "color-gray-800 cursor-pointer, button__arrow",
                                  {
                                    "visibility-hidden":
                                      date !== highlightedDate && isWide,
                                  }
                                )}
                                icon={<Icon url={faArrowRight} path={path} />}
                                onClick={() => {
                                  swiperMenu.updateSlides();
                                  swiperMenu.slideNext();
                                  fetchSingleMenu(selectedDiet, [
                                    getNewFetchDate("up", dates),
                                  ]);
                                  setDates(newChangeDates("up", dates));
                                  setHighLightedDate(
                                    getNewHighlightedDate(highlightedDate, "up")
                                  );
                                }}
                              />
                            </div>
                            {menus[date]?.length > 0 ? (
                              <div className="catering-menu__box-menu">
                                <span className="h300 spacer-bottom-16 hidden-up-md">
                                  {parseDay("cccc", date)},{" "}
                                  {parseDay("d.LL.yyyy", date)}
                                </span>
                                {customNumSort("priority")(menus[date])?.map(
                                  (meal) => {
                                    return (
                                      <div
                                        className="spacer-top-12"
                                        key={meal?.menuMealId}
                                      >
                                        <h6 className="label-m">
                                          {meal?.mealName}:{" "}
                                          <span className="body-m">
                                            {meal?.menuMealName}
                                          </span>
                                        </h6>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ) : (
                              <MenuUnavailable />
                            )}
                          </div>
                        )}
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
            )}
          </div>
        ) : (
          <NoDiets />
        )}
        <Footer />
      </div>
    </>
  );
};
